var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "staffDetailModal",
        width: 443,
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minHeight: 900
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "staffDetailWrapper" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "staff-name" }, [
              _vm._v(_vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              {
                staticClass: "modal-close-img",
                on: {
                  click: function($event) {
                    _vm.hideModal()
                  }
                }
              },
              [_c("div", { staticClass: "icon-close" })]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "label" }, [_vm._v("FIRST NAME")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.firstName))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "label" }, [_vm._v("LAST NAME")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.lastName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("EMAIL")]),
            _vm._v(" "),
            _c("div", { staticClass: "information" }, [
              _vm._v(_vm._s(_vm.email))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("PHONE NUMBER")]),
            _vm._v(" "),
            _c(
              "div",
              {},
              [
                _c("the-mask", {
                  staticClass: "information input-staff",
                  attrs: {
                    mask: "(###) ###-####",
                    masked: _vm.isDisable,
                    disabled: _vm.isDisable
                  },
                  model: {
                    value: _vm.phone,
                    callback: function($$v) {
                      _vm.phone = $$v
                    },
                    expression: "phone"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("ROLES")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v(_vm._s(_vm.role))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("HOURLY RATE")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v("$ " + _vm._s(_vm.payRates))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "label" }, [_vm._v("ADDRESS")]),
            _vm._v(" "),
            _c("div", { staticClass: "information text-role" }, [
              _vm._v(_vm._s(_vm.address))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("div", { staticClass: "label" }, [
                _vm._v("EVENT (" + _vm._s(_vm.totalEvents) + ")")
              ]),
              _vm._v(" "),
              _vm._l(_vm.eventList, function(event) {
                return _c(
                  "div",
                  {
                    staticClass: "event-link",
                    on: {
                      click: function($event) {
                        _vm.goToEventDetail(event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(event.eventName) + "\n        "
                    )
                  ]
                )
              })
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b438a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b438a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/staff/StaffDetailModal.vue
// module id = 2097
// module chunks = 1